import api from "./api";

function getAll(lang) {
  return new Promise((resolve, reject) => {
    return api.get(`/projects/${lang}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

function getBySlug(lang, slug) {
  return new Promise((resolve, reject) => {
    return api.get(`/projects/${lang}/${slug}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export default {
  getAll,
  getBySlug
}